import moment from "moment";

/**
 * Formatting for the teleconsultation call log (NABH COP.7.a steps 6-7) — the
 * patient's own view of when the consultation ran and how long it lasted.
 * Mirrors the doctor app's helper of the same name.
 */

export const formatCallTime = (value) =>
  value ? moment(value).format("hh:mm A") : "";

export const formatCallDuration = (seconds) => {
  if (seconds === null || seconds === undefined) return "";
  if (seconds < 60) return `${Math.max(0, Math.round(seconds))} sec`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest ? `${hours} hr ${rest} min` : `${hours} hr`;
};

/**
 * One line per call, newest first, straight off the appointment document —
 * the booking payload already carries `videoConsultation.sessions`.
 */
export const describeVideoConsultation = (appointment) => {
  const sessions = appointment?.videoConsultation?.sessions || [];

  return sessions
    .filter((session) => session?.startedAt)
    .map((session) => {
      const started = formatCallTime(session.startedAt);
      if (!session.endedAt) return `In progress · started ${started}`;
      const duration = formatCallDuration(
        session.durationSeconds ||
          Math.max(
            0,
            Math.round(
              (new Date(session.endedAt).getTime() -
                new Date(session.startedAt).getTime()) /
                1000,
            ),
          ),
      );
      const window = `${started} – ${formatCallTime(session.endedAt)}`;
      return duration ? `${window} · ${duration}` : window;
    })
    .reverse();
};
